import dayjs from "dayjs";
import { formatCurrencyDe } from "@/shared/utils";
import type { Order } from "@/data/Order.ts";
import type { OrderItem, OrderPayment } from "@/pos/OrderType.ts";
import type { Eod } from "@/data/Eod.ts";
import { Bonpos } from "@/tse/dsfinv/dsfinvModel2.ts";
import { getPayment } from "@/tse/makeProcessDataLib.ts";
import { getZERSTELLUNG } from "@/tse/dsfinv/dsfinv-convert.ts";
import { masterDeviceSetting } from "@/data/utils/MasterDeviceSetting.ts";

export const Bonkopf_Zahlarten = {
  Z_KASSE_ID: {
    type: "string",
    maxLength: 50,
    hint: "ID der (Abschluss-) Kasse"
  },
  Z_ERSTELLUNG: {
    type: "datetime",
    hint: "Zeitpunkt des Kassenabschlusses"
  },
  Z_NR: {
    type: "number",
    places: 0,
    hint: "Nr. des Kassenabschlusses"
  },
  BON_ID: {
    type: "string",
    maxLength: 40,
    hint: "Vorgangs-ID"
  },
  ZAHLART_TYP: {
    type: "string",
    maxLength: 25,
    hint: "Typ der Zahlart"
  },
  ZAHLART_NAME: {
    type: "string",
    maxLength: 60,
    hint: "Name der Zahlart"
  },
  ZAHLWAEH_CODE: {
    type: "string",
    maxLength: 3,
    hint: "Währungscode",
    regex: "^[A-Z]{3}$"
  },
  ZAHLWAEH_BETRAG: {
    type: "number",
    places: 2,
    hint: "Betrag in Fremdwährung"
  },
  BASISWAEH_BETRAG: {
    type: "number",
    places: 2,
    hint: "Betrag in Basiswährung (i.d.R. EUR)"
  }
}
export function Bonkopf_ZahlartenFactory(order: Order, eod: Eod){
  let payment: OrderPayment;
  let voucherItem: OrderItem;
  let voucherProcess: boolean = false;

  return build();
  function build() {
    const rows = []
    for (const _payment of order.payments) {
      payment = _payment;
      rows.push(buildSingle());
    }
    voucherProcess = true;
    for (const _item of order.items) {
      if (!_item.isVoucher) continue;
      voucherItem = _item;
      rows.push(buildSingle());
    }
    return rows;
  }

  function buildSingle(){
    return{
      Z_KASSE_ID: Z_KASSE_ID(),
      Z_ERSTELLUNG: Z_ERSTELLUNG(),
      Z_NR: Z_NR(),
      BON_ID: BON_ID(),
      ZAHLART_TYP: ZAHLART_TYP(),
      ZAHLART_NAME: ZAHLART_NAME(),
      ZAHLWAEH_CODE: ZAHLWAEH_CODE(),
      ZAHLWAEH_BETRAG: ZAHLWAEH_BETRAG(),
      BASISWAEH_BETRAG: BASISWAEH_BETRAG()
    }
  }
  function Z_KASSE_ID() {
    // hint: "ID der (Abschluss-) Kasse"
    return masterDeviceSetting()?._id
  }

  function Z_ERSTELLUNG() {
    // hint: "Zeitpunkt des Kassenabschlusses"
    return getZERSTELLUNG(eod)
  }

  function Z_NR() {
    return order.z;
  }

  function BON_ID() {
    return order.id;
  }

  function ZAHLART_TYP() {
    // hint: "Typ der Zahlart"
    if (voucherProcess) return 'Unbar';
    return getPayment(payment);
  }

  function ZAHLART_NAME() {
    // hint: "Name der Zahlart"
    return voucherProcess ? 'Voucher' : payment.type;
  }

  function ZAHLWAEH_CODE() {
    // hint: "Währungscode"
    return 'EUR';
  }

  function ZAHLWAEH_BETRAG() {
    // hint: "Betrag in Fremdwährung"
    return formatCurrencyDe(0);
  }

  function BASISWAEH_BETRAG() {
    // hint: "Betrag in Basiswährung (i.d.R. EUR)"
    return formatCurrencyDe(voucherProcess ? voucherItem.vSum! : payment.value!);
  }
}